import React, { useEffect } from 'react';
// import ReactGA from 'react-ga4';

const Step4 = ({ formData, handleInputChange, setStep }) => {
  useEffect(() => {
    // const pageName = 'Step4';
    // ReactGA.event({
    //   category: 'Navigation',
    //   action: 'Page View',
    //   page_name: pageName
    // });
    sessionStorage.setItem('lastPage', 'Step4');
  }, []);

  const handleFormSubmit = (answer) => {
    handleInputChange({ target: { name: 'previousFracture', value: answer === 'yes' } });
    setStep(6);
  };

  return (
    <div className="p-4 bg-blue-100 rounded-lg">
      <h2 className="common-title mb-4">ステップ 4</h2>
      <p className="text-base mb-4 text-lg">これまでに骨折したことがありますか？<br /><br />
        <span className="underline-wavy text-red-500">※不明な場合は、「いいえ」を選んでください。</span>
      </p>
      <p className="text-regular text-lg mb-5">※立っている状態から転んだりそれ以下の弱い力で骨折をした場合は、「はい」を選んでください。</p>
      <p className="text-regular text-lg mb-5">※交通事故や転落など大きな力が加わって起きた骨折は除外してください。</p>
      <br />
      <div className="flex justify-between">
        <button 
          onClick={() => setStep(4)} 
          className="bg-gray-500 text-white p-2 rounded hover:bg-gray-600 w-auto"
        >
          前の画面へもどる
        </button>
        <button 
          onClick={() => handleFormSubmit('yes')} 
          className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600 w-auto"
        >
          はい
        </button>
        <button 
          onClick={() => handleFormSubmit('no')} 
          className="bg-pink-500 text-white p-2 rounded hover:bg-pink-600 w-auto"
        >
          いいえ
        </button>
      </div>
    </div>
  );
};

export default Step4; 